import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { MeshCompNodeDeps } from './mesh.types'
import {
	createMeshContainer,
	getMeshForColumns,
	getMeshForContainer,
	getMeshForHoverBox,
	getMeshForMasterPage,
} from './meshCompNodeHelpers'

export const mesh = (isEditor: boolean) =>
	createCssCompNode('mesh', 'mesh', {
		getDependencies: (component, refs: FeatureRefs<'mesh'>) => {
			// TODO: make optimization for component.type !== 'Container'. Mesh doesn't use leafs components compData
			const compData = {
				props: refs.propertyQuery(component.propertyQuery!),
				style: refs.styleId(component.styleId!),
				data: refs.dataQuery(component.dataQuery!),
			}

			const siteHeader = component.componentType === 'MasterPage' ? refs.meshChild('SITE_HEADER') : undefined
			const pagesContainerSingleLayout =
				component.componentType === 'MasterPage' ? refs.compSingleLayout('PAGES_CONTAINER') : undefined

			return {
				meshComp: refs.meshChild(component.id),
				compData,
				siteHeader, // for mesh1
				pagesContainerSingleLayout, // for mesh3
				siteWidth: envRefs.siteWidth,
				absoluteComps: envRefs.meshRuntimeData_absoluteComps,
				isOneDocMigrated: envRefs.isOneDocMigrated,
			}
		},
		toViewItem: (__, deps) => {
			if (!deps.meshComp || !deps.meshComp.shouldCalculateMesh) {
				return null
			}

			// use component from meshComp node instead of the original one, since its children already filtered and contains only mesh relevant children
			const component = deps.meshComp.component

			if (component.componentType === 'MasterPage') {
				return {
					meshResults: [getMeshForMasterPage(component, deps as MeshCompNodeDeps)],
				}
			}

			if (component.componentType === 'StripColumnsContainer') {
				return getMeshForColumns(component, deps as MeshCompNodeDeps, isEditor)
			}

			// only for mesh1
			if (component.componentType === 'HoverBox') {
				return getMeshForHoverBox(component, deps as MeshCompNodeDeps)
			}

			if (component.componentType === 'PopupContainer' || component.componentType === 'Page') {
				const newContainer = createMeshContainer(component, deps as MeshCompNodeDeps)

				return { meshResults: [getMeshForContainer(newContainer, deps as MeshCompNodeDeps, isEditor)] }
			}

			return { meshResults: [getMeshForContainer(component, deps as MeshCompNodeDeps, isEditor)] }
		},
	})
